export const SUBSCRIPTIONS_SORT_VALUE = "SET_SUBSCRIPTIONS_SORT_VALUE";
export const SINGLE_SUBSCRIPTION = "SET_SINGLE_SUBSCRIPTION";
export const SET_SUPPRESSION_PREVIEW_DATA = "SET_SUPPRESSION_PREVIEW_DATA";
export const SET_SUPPRESSION_STEP = "SET_SUPPRESSION_STEP";

export const setSubscriptionsSortValue = (subscriptionsSortValue) => ({
	type: SUBSCRIPTIONS_SORT_VALUE,
	subscriptionsSortValue,
});

export const setSingleSubscription = (singleSubscription) => ({
	type: SINGLE_SUBSCRIPTION,
	singleSubscription,
});

export const setSuppressionPreviewData = (data) => ({
	type: SET_SUPPRESSION_PREVIEW_DATA,
	payload: data
});

export const setSuppressionStep = (step) => {
	const action = {
		type: SET_SUPPRESSION_STEP,
		payload: step
	};
	return action;
};
